<template>
  <div class="button " :class="{btndisabled:btnDisabled}">
    <a :href="link" v-if="link" class="button" :download="download">
      <div class="button_text">{{ text }}</div>
    </a>
    <div v-else class="button_text" @click="$emit('myclick')">
      {{ text }} <span v-if="timerview && timerCount>0">({{ timerCount }})</span>
    </div>
    <svg
      class="button-svg-right"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 0V12H0L12 0Z" :fill="anglecolor" />
    </svg>
    <svg
      class="button-svg-left"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 12V0H12L0 12Z" :fill="anglecolor" />
    </svg>
  </div>
</template>
<script>
import { computed, ref, watch } from "vue";
export default {
  name: "ButtonComponent",
  props: ["link", "text", "acolor", "download", "timer", "timerview", "disabled"],
  emits:["disabledEvent"],
  setup(props,{emit}) {
    const timerCount = ref(props.timer);
    const btnDisabled = ref(props.disabled);
    const anglecolor=computed(()=>{
      if (props.acolor === "" || props.acolor === undefined) return "white";
      return props.acolor;
    })
    if(timerCount.value!=undefined && props.timer>0){
      btnDisabled.value = true;
      setTimeout(() => {
            timerCount.value--;
          }, 1000);
    }
   // console.log(props.timer)
    watch(
      ()=>props.disabled,
      ()=>{
        btnDisabled.value=props.disabled
      }
    )
    watch(
      () => props.timer,
      () => {
      //  console.log(props.timer)
        if (props.timer > 0) {
          timerCount.value = props.timer;
          btnDisabled.value = true;
        }
      }
    );

    watch(
      () => timerCount.value,
      () => {
        if (timerCount.value > 0) {
          setTimeout(() => {
            timerCount.value--;
          }, 1000);
        } else {
          btnDisabled.value = false;
          emit("disabledEvent",btnDisabled.value );
        }
      }
    );
    return {
      timerCount,
      btnDisabled,
      anglecolor,
      
    };
  },
  
};
</script>
<style>
.button {
  position: relative;
  width: 238px;
  height: 44px;
  text-decoration: none;
  background-color: #e82862;
  cursor: pointer;
}
.btndisabled {
  background-color: #ddd !important;
}
.button_text {
  padding-top: 11px;
  height: 100%;
  font-family: Proxima Nova;
  text-align: center;
  font-style: normal;
  /*  font-weight: bold;*/
  font-size: 17px;
  line-height: 21px;
  /* identical to box height */
  color: #ffffff;
}
.button svg.button-svg-right {
  position: absolute;
  bottom: -1px;
  right: -1px;
}
.button svg.button-svg-left {
  position: absolute;
  top: -1px;
  left: -1px;
}
</style>
